import { useContext, useEffect } from 'react';
import { RoutePath } from '@business/seller';
import { getRouteByPath } from '@features/m4b-components-new/src/router/utils';
import { AppRuntimeContext } from '@/App';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
var SellerPaths = RoutePath.SellerPaths;
var ALWAYS_PASSED_ALLOW_LIST = [SellerPaths.QUOTA_RULE_OVERVIEW];
export default (function (props) {
  var children = props.children;
  var _useContext = useContext(AppRuntimeContext),
    menus = _useContext.menus,
    mainHistory = _useContext.history;
  useEffect(function () {
    if (menus) {
      var currentPathname = mainHistory.location.pathname || '/';
      var route = getRouteByPath(menus, currentPathname, false);
      if (!route && !ALWAYS_PASSED_ALLOW_LIST.includes(currentPathname)) {
        mainHistory.push(SellerPaths.HOMEPAGE || '/');
      }
    }
  }, [menus, mainHistory.location.pathname]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
});